import { render, staticRenderFns } from "./ExtActProcessConfigModal.vue?vue&type=template&id=ff068050&scoped=true&"
import script from "./ExtActProcessConfigModal.vue?vue&type=script&lang=js&"
export * from "./ExtActProcessConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./ExtActProcessConfigModal.vue?vue&type=style&index=0&id=ff068050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff068050",
  null
  
)

export default component.exports